import { useContext, useEffect, useState } from "react";
import { StandardButton } from "../atoms/buttons";
import { LayoutButton } from "../atoms/presentation";
import { CourseComp } from "../components/courseComp";
import { CourseTableComp } from "../components/courseTableComp";

import {
  GridLayout,
  HorizontalLayout,
  VerticalLayout,
  VerticalPageLayout,
} from "../components/layout";
import { ActionBar } from "../molecule/actionBar";
import { getAPI, postAPI, updateAPI } from "../api/api";
import { SkeletonCardCourses } from "../atoms/skeletonloaders";
import { icon } from "../functions/icons";
import { CreateCourseModal, SortingModal } from "../components/customModals";
import { PageContext, UserContext } from "../App";
import { Spinner } from "../atoms/spinner";
import { ShowLayoutError } from "../molecule/ShowErrorLayout";

export function Courses({ pageSwap, courseToUpdate, setCourseToUpdate, AiStarted, CustomerStage, titleScreen }) {
  const userContext = useContext(UserContext);
  const [listCourses, setListCourses] = useState([]);
  const [presentationStyle, setPresentationStyle] = useState(2);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [filterModalVisibility, setFilterModalVisibility] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigationContext = useContext(PageContext);
  function updateCourseAiMode(courseToUpdateId) {
    setListCourses(prevCourses => {
      return prevCourses.map(course => {
        if (course.id_course === courseToUpdateId) {
          return { ...course, ai_mode: 0 };
        }
        return course;
      });
    });
    setCourseToUpdate(null);
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [createCourseModalVisibility, setCreateCourseModalVisibility] = useState(false);
  const [sortingOptions, setSortingOptions] = useState({
    sort_by: navigationContext.sidebar?.sort_by || "creation_date",
    type: navigationContext.sidebar?.order || "DESC",
    filters: navigationContext.sidebar?.filters ? navigationContext.sidebar.filters.split(",") : ["active_lessons", "inactive_lessons", "deactivated_lessons"],
  });

  async function applySortOptions() {
    setFilterModalVisibility(false);
    const copySortingOptions = { ...sortingOptions };
    const filtersQuery = copySortingOptions.filters.join(","); 
    navigationContext.handleNavigation({...navigationContext.sidebar,sort_by: copySortingOptions.sort_by, order: copySortingOptions.type,  filters: filtersQuery})
    await fetchCourses(copySortingOptions.sort_by, copySortingOptions.type, filtersQuery);
  }
  async function fetchCourses(sort_by = "creation_date", order = "DESC", filters = "") {
    setLoadingCourses(true);

    var query = `api/courses/filter?filter=${sort_by}&order=${order}&published_filters=${filters}&customer_stage=${CustomerStage}`;
    if(navigationContext.sidebar?.sort_by){
      
      const sort_by = navigationContext.sidebar.sort_by;
      const order = navigationContext.sidebar.order;
      const filters = navigationContext.sidebar.filters;
      query = `api/courses/filter?filter=${sort_by}&order=${order}&published_filters=${filters}&customer_stage=${CustomerStage}`;
       }
    const res = await getAPI(query);
    console.log(res);
    if (res.status === "ok") {
      setListCourses(res.data);
      setLoadingCourses(false);
    }
   
  }
  const handleCourseModal = () => {
    setCreateCourseModalVisibility(!createCourseModalVisibility);
  };


  function aiCourseCreated() {
    setCreateCourseModalVisibility(false)
    fetchCourses()
  }
  useEffect(() => {
    updateCourseAiMode(courseToUpdate);
  }, [courseToUpdate, setCourseToUpdate]);

  useEffect(() => {
    fetchCourses();
  }, [userContext]);

  const handleRetry = async (courseId) => {
    const query = "api/courses/retry";
    const body = { id_course: courseId };
    const res = await postAPI(query, body);
    if (res.status === "ok") {
      fetchCourses();
    }
  };
  const removeCourse = async (courseId) => {
    const query = "api/courses/delete";
    const body = { id_course: courseId };
    const res = await updateAPI(query, body);
    if (res.status === "ok") {
      fetchCourses();
    }
  };
  function getCourseStatus(course) {
    const progress = parseInt(course.progress, 10);
    const published = course.published;
    const active = course.active;
    const statusMap = [
      { check: () => published === 0, status: "notPublished" },
      { check: () => published === 2, status: "inactive" },
      { check: () => published === 1 && progress === 0, status: "published" },
      { check: () => published === 1 && progress > 0 && progress < 100, status: "inProgress" },
      { check: () => published === 1 && progress === 100 && active === 2, status: "finished" },
      { check: () => published === 1 && progress === 100, status: "published" } 
    ];

    const found = statusMap.find(entry => entry.check());
    return found ? found.status : "unknown";
  }

  return (
    <VerticalPageLayout
      className={`page-in-animation ${pageSwap && "page-out-animation"}`}
    >
      <SortingModal
        setSortingOptions={setSortingOptions}
        applySortOptions={async () => await applySortOptions()}
        sortingOptions={sortingOptions}
        dismissedModal={() => setFilterModalVisibility(false)}
        visible={filterModalVisibility}
      />
      <CreateCourseModal
        CustomerStage={CustomerStage}
        AiStarted={AiStarted}
        aiCourseCreated={aiCourseCreated}
        dismissedModal={handleCourseModal}
        visible={createCourseModalVisibility}
      />

      <VerticalLayout className="standard-padding" style={{ width: "unset" }}>
        <ActionBar
          title={titleScreen ? titleScreen : "Cursussen"}
          actionButton={
            <>
              {userContext.permissions.includes("courses.manage") && <StandardButton
                title={isMobile ? "" : `Nieuwe cursus`}
                arrow=""
                onClick={handleCourseModal}
                className={"semi-bold phone-plus-icon"}
              >
                {isMobile && icon("plus", 30)}
              </StandardButton>}
            </>
          }
          filterButtons={
            <HorizontalLayout style={{ width: "unset", gap: "1rem" }}>
              {/* <FilterButton /> */}
              <StandardButton
                title={isMobile ? "" : `Sorteren`}
                arrow="down"
                onClick={() => setFilterModalVisibility(true)}
              >{isMobile && icon("sorter")}</StandardButton>
              <LayoutButton
                listViewFunction={() => setPresentationStyle(1)}
                gridViewFunction={() => setPresentationStyle(2)}
                currentPresentation={presentationStyle}
              />
            </HorizontalLayout>
          }
        />
        <RenderLayout presentationStyle={presentationStyle} listCourses={listCourses} loadingCourses={loadingCourses} getCourseStatus={getCourseStatus} handleRetry={handleRetry} remove={removeCourse} CustomerStage={CustomerStage} />
      </VerticalLayout>
    </VerticalPageLayout>
  );
}


const RenderLayout = ({presentationStyle, listCourses, loadingCourses, getCourseStatus, handleRetry,remove,CustomerStage}) => {
  const navigationContext = useContext(PageContext);

  switch (presentationStyle) {
    case 1: return (
        <CourseTableComp
          courses={listCourses}
          loading={loadingCourses}
          courseOpen={(course) =>
            navigationContext.handleNavigation({
              navigation: course.published ? CustomerStage == 5 ? 702 : 7 : CustomerStage == 5 ? 408 : 5,
              courseID: course.id_course,
              enrollment: 0,
              back_page: navigationContext.sidebar?.navigation
            })
          }
        />
      );
      case 2: return <CourseGridComp loadingCourses={loadingCourses} listCourses={listCourses} getCourseStatus={getCourseStatus} handleRetry={handleRetry} remove={remove} CustomerStage={CustomerStage} />;
      default: return <ShowLayoutError
          iconType={"book-off"}
          errorTitle={"geen cursussen gevonden"}
          message={"Probeer een andere zoekterm of andere filters."}
        />
  }

}
function CourseGridComp({loadingCourses, listCourses, getCourseStatus, handleRetry,remove, CustomerStage}) {
  const navigationContext = useContext(PageContext);

    return loadingCourses ? (
      <SkeletonCardCourses />
    ) : (
      <GridLayout
        className="course-grid"
        style={{ gridAutoRows: "240px" }}
        columnsTemplate="1fr 1fr 1fr 1fr"
        gap="16px"
      >
        {listCourses.map((course, idx) => (
          <CourseComp
            key={`${course.id_course}-${idx}`}
            className={`${course.ai_mode === 1 ? "course-loading" : ""} ${course.ai_mode === 4 ? "course-failed" : ""}`}
            onClick={() =>
              navigationContext.handleNavigation({
                navigation: course.published ? CustomerStage == 5 ? 702 : 7 : CustomerStage == 5 ? 408 : 5,
                courseID: course.id_course,
                enrollment: 0,
                back_page: navigationContext.sidebar?.navigation
              })
            }
            title={course.title}
            duration={`${course.moduleCount * 3}m`}
            lessons={course.lessonCount}
            status={getCourseStatus(course)}
            image={course.image_url}
            AI={course.ai_mode === 1 ? true : false}
            error={course.ai_mode === 4 ? true : false}
            onRetry={() => handleRetry(course.id_course)}
            remove={() => remove(course.id_course)}
          />
        ))}
      </GridLayout>
    );
  }